export default __webpack_public_path__ + "static/media/num-1.2c30e7b8.svg";